import { PictureManager } from "./components/PictureManager.js";

PictureManager.use();
